export default function tabs() {
  // Js Classes
  const tabsContentClass = 'js-tabs-content';
  const tabsRadioClass = 'js-tabs-radio';
  const tabsButtonClass = 'js-tabs-button';
  const tabsViewAllClass = 'js-tabs-view-all';

  // CSS Classes
  const activeContentClass = 'o-tabs__content--active';
  const activeButtonClass = 'o-tabs__button--active';
  const activeMenuClass = 'o-tabs__menu--active';
  const activeRadioButtonClass = 'js-tabs-radio--active';
  const mobileButtonClass = 'o-tabs__button--mobile';

  // Elements
  const elTabs = document.querySelectorAll('.js-tabs');

  function initListeners(elTabsContainer) {
    function toggleMenu(toggleOff = false) {
      const elTabsMenu = elTabsContainer.querySelector('.js-tabs-menu');
      const menuState = elTabsMenu.classList.contains(activeMenuClass);
      if (menuState || toggleOff) elTabsMenu.classList.remove(activeMenuClass);
      else elTabsMenu.classList.add(activeMenuClass);
    }

    function setMobileButtons(button) {
      const elMobileButtons = elTabsContainer.querySelectorAll(`.${mobileButtonClass}`);
      elMobileButtons.forEach((elem) => elem.classList.remove(mobileButtonClass));
      button.classList.add(mobileButtonClass);
      if (button.previousSibling) button.previousSibling.classList.add(mobileButtonClass);
      else button.nextSibling.classList.add(mobileButtonClass);
    }

    function switchActiveContent(dataTab) {
      const elButton = elTabsContainer.querySelector(`.${tabsButtonClass}[data-tab="${dataTab}"]`);
      const elContent = elTabsContainer.querySelector(`.${tabsContentClass}[data-tab="${dataTab}"]`);
      const elRadio = elTabsContainer.querySelector(`.${tabsRadioClass}[data-tab="${dataTab}"]`);
      const elRadioInput = elRadio.querySelector('input');

      const activeButton = elTabsContainer.querySelector(`.${activeButtonClass}`);
      const activeRadio = elTabsContainer.querySelector(`.${activeRadioButtonClass}`);
      const activeRadioInput = activeRadio.querySelector('input');
      const activeContent = elTabsContainer.querySelector(`.${activeContentClass}`);

      // Remove active elements
      activeButton.classList.remove(activeButtonClass);
      activeContent.classList.remove(activeContentClass);
      activeRadio.classList.remove(activeRadioButtonClass);
      activeRadioInput.checked = false;

      // Set active elements
      elButton.classList.add(activeButtonClass);
      elContent.classList.add(activeContentClass);
      elRadio.classList.add(activeRadioButtonClass);
      elRadioInput.checked = true;

      toggleMenu(true);
    }

    function clickEvent(e) {
      if (e.target.classList.contains(tabsButtonClass) || e.target.classList.contains(tabsRadioClass)) {
        const dataTab = e.target.dataset.tab;
        if (e.target.classList.contains(activeButtonClass)) return;
        switchActiveContent(dataTab);
      }

      if (e.target.tagName === 'INPUT') {
        const dataTab = e.target.closest(`.${tabsRadioClass}`).dataset.tab;
        const elButton = elTabsContainer.querySelector(`.${tabsButtonClass}[data-tab="${dataTab}"]`);
        switchActiveContent(dataTab);
        setMobileButtons(elButton);
      }

      if (e.target.classList.contains(tabsViewAllClass)) {
        toggleMenu();
      }
    }

    elTabsContainer.addEventListener('click', clickEvent);
    const firstRadioButton = elTabsContainer.querySelector(`.${activeRadioButtonClass} input`);
    firstRadioButton.checked = true;
  }

  function init() {
    elTabs.forEach((tabsComponent) => {
      initListeners(tabsComponent);
    });
  }

  if (elTabs) init();
}
